//
// Imports
//

import 
{ 
	initialiseControls,
	initialiseForms,

	initialiseHumanDateTimes,
	initialiseHumanRelativeTimes,
	initialiseNotices,
	initialiseTables
} from "@donutteam/document-builder-components/build/client.js";

import { initialiseCookieBanners } from "./components/banners/CookieBanner.client.js";

import { initialiseUpsertBlogPostForms } from "./components/blogs/UpsertBlogPostForm.client.js";

import { initialiseJoinedLastThirtyDaysStatisticsCharts } from "./components/charts/JoinedLastThirtyDaysStatisticsChart.client.js";

import { initialiseColorInputs } from "./components/form-inputs/ColorInput.client.js";
import { initialiseMultiInputs } from "./components/form-inputs/MultiInput.client.js";
import { initialisePasswordStrengthBars } from "./components/form-inputs/PasswordStrengthBar.client.js";

import { initialiseAcknowledgePenaltyForms } from "./components/forms/penalties/AcknowledgePenaltyForm.client.js";

import { initialiseDesignPreferencesForms } from "./components/forms/preferences/DesignPreferencesForm.client.js";
import { initialiseForumBoardPreferencesForms } from "./components/forms/preferences/ForumBoardPreferencesForm.client.js";
import { initialiseQuickDrawerPreferencesForms } from "./components/forms/preferences/QuickDrawerPreferencesForm.client.js";

import { initialiseAboutForms } from "./components/forms/profiles/AboutForm.client.js";
import { initialiseColorForms } from "./components/forms/profiles/ColorForm.client.js";
import { initialisePronounForms } from "./components/forms/profiles/PronounForm.client.js";
import { initialiseShowcaseForms } from "./components/forms/profiles/ShowcaseForm.client.js";
import { initialiseWebsiteForms } from "./components/forms/profiles/WebsiteForm.client.js";

import { initialiseCreateSessionForms } from "./components/forms/sessions/CreateSessionForm.client.js";
import { initialiseInvalidateSessionForms } from "./components/forms/sessions/InvalidateSessionForm.client.js";

import { initialiseDeveloperSettingsForms } from "./components/forms/settings/DeveloperSettingsForm.client.js";
import { initialiseExperimentSettingsForms } from "./components/forms/settings/ExperimentSettingsForm.client.js";
import { initialiseSafetySettingsForms } from "./components/forms/settings/SafetySettingsForm.client.js";

import { initialiseAvatarForms } from "./components/forms/users/AvatarForm.client.js";
import { initialiseCreateAccountForms } from "./components/forms/users/CreateAccountForm.client.js";
import { initialiseDeleteAccountForms } from "./components/forms/users/DeleteAccountForm.client.js";
import { initialiseDisableAccountForms } from "./components/forms/users/DisableAccountForm.client.js";
import { initialiseDisplayNameForms } from "./components/forms/users/DisplayNameForm.client.js";
import { initialiseEmailChangeForms } from "./components/forms/users/EmailChangeForm.client.js";
import { initialiseForgotPasswordForms } from "./components/forms/users/ForgotPasswordForm.client.js";
import { initialisePasswordForms } from "./components/forms/users/PasswordForm.client.js";
import { initialiseTokenForms } from "./components/forms/users/TokenForm.client.js";
import { initialiseUsernameForms } from "./components/forms/users/UsernameForm.client.js";

import { initialiseCreateReleaseBranchVersionFileForms } from "./components/forms/CreateReleaseBranchVersionFileForm.client.js";
import { initialiseIssuePenaltyForms } from "./components/forms/IssuePenaltyForm.client.js";
import { initialiseSearchForms } from "./components/forms/SearchForm.client.js";
import { initialiseUpdateReleaseMediaSortOrderForms } from "./components/forms/UpdateReleaseMediaSortOrderForm.client.js";

import { initialiseUserGrids } from "./components/grids/UserGrid.client.js";

import { initialiseLinkHierarchySidebars } from "./components/sidebars/LinkHierarchySidebar.client.js";

import { initialiseForumTopicReplySummaries } from "./components/summaries/ForumTopicReplySummary.client.js";
import { initialiseReleaseSummaries } from "./components/summaries/ReleaseSummary.client.js";

import { initialiseGlobalNavigations } from "./components/GlobalNavigation.client.js";
import { initialiseGlobalQuickDrawers } from "./components/GlobalQuickDrawer.client.js";
import { initialisePopupOpenElements } from "./components/Popup.client.js";
 
//
// PJAX
//

export function initialiseSharedComponents()
{
	//
	// Document Builder Components
	//

	// Forms
	initialiseControls();
	initialiseForms();

	// Other
	initialiseHumanDateTimes();
	initialiseHumanRelativeTimes();
	initialiseNotices();
	initialiseTables();

	//
	// Donut Team Components
	//

	// Banners
	initialiseCookieBanners();

	// Blogs
	initialiseUpsertBlogPostForms();

	// Charts
	initialiseJoinedLastThirtyDaysStatisticsCharts();

	// Form Inputs
	initialiseColorInputs();
	initialiseMultiInputs();
	initialisePasswordStrengthBars();

	// Forms > Penalties
	initialiseAcknowledgePenaltyForms();

	// Forms > Preferences
	initialiseDesignPreferencesForms();
	initialiseForumBoardPreferencesForms();
	initialiseQuickDrawerPreferencesForms();

	// Forms > Profiles
	initialiseAboutForms();
	initialiseColorForms();
	initialisePronounForms();
	initialiseShowcaseForms();
	initialiseWebsiteForms();

	// Forms > Sessions
	initialiseCreateSessionForms();
	initialiseInvalidateSessionForms();

	// Forms > Settings
	initialiseDeveloperSettingsForms();
	initialiseExperimentSettingsForms();
	initialiseSafetySettingsForms();

	// Forms > Users
	initialiseAvatarForms();
	initialiseCreateAccountForms();
	initialiseDeleteAccountForms();
	initialiseDisableAccountForms();
	initialiseDisplayNameForms();
	initialiseEmailChangeForms();
	initialiseForgotPasswordForms();
	initialisePasswordForms();
	initialiseTokenForms();
	initialiseUsernameForms();

	// Forms
	initialiseCreateReleaseBranchVersionFileForms();
	initialiseIssuePenaltyForms();
	initialiseSearchForms();
	initialiseUpdateReleaseMediaSortOrderForms();

	// Grids
	initialiseUserGrids();

	// Sidebars
	initialiseLinkHierarchySidebars();

	// Summaries
	initialiseForumTopicReplySummaries();
	initialiseReleaseSummaries();

	// Other
	initialiseGlobalNavigations();
	initialiseGlobalQuickDrawers();
	initialisePopupOpenElements();
}